import { useState } from "react"
import { Row, Col, Spinner } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import Settings from "@/common/Settings"
import { APIService } from "@/common/API"

interface FileRecord {
  id: string
  filePath: string
}

interface Props {
  files: FileRecord[]
  canDelete?: boolean
  onDeleted?: (id: string) => void
}

const IncidentFileGallery = ({ files, canDelete = false, onDeleted }: Props) => {
  const { t } = useTranslation("global")
  const [deletingId, setDeletingId] = useState<string | null>(null)

  const handleDelete = async (id: string) => {
    setDeletingId(id)
    try {
      await APIService.getAction("Incident/Files/Delete", `id=${id}`)
      onDeleted?.(id)
    } finally {
      setDeletingId(null)
    }
  }

  if (files.length === 0) return null

  return (
    <Row className="g-2 mt-1">
      {files.map(f => (
        <Col key={f.id} xs={4} md={3} className="position-relative">
          <a href={`${Settings.BasePath}${f.filePath}`} target="_blank" rel="noreferrer">
            <img
              src={`${Settings.BasePath}${f.filePath}`}
              alt=""
              className="img-thumbnail w-100"
              style={{ height: 80, objectFit: "cover" }}
            />
          </a>
          {canDelete && (
            <button
              className="btn btn-danger btn-sm position-absolute top-0 end-0 p-0 px-1"
              style={{ fontSize: 10, lineHeight: 1.5 }}
              onClick={() => handleDelete(f.id)}
              disabled={deletingId === f.id}
              title={t("Delete")}
            >
              {deletingId === f.id ? <Spinner animation="border" size="sm" /> : "×"}
            </button>
          )}
        </Col>
      ))}
    </Row>
  )
}

export default IncidentFileGallery
